class PDPAccordion extends HTMLElement {
  constructor() {
    super();
    this._isInitialized = false;
        this._originalContent = null;

  }

  static get observedAttributes() {
    return [
      'heading',
      'icon'
    ];
  }

  connectedCallback() {
    if (!this._isInitialized) {
            // Store original content BEFORE rendering
      this._originalContent = this.innerHTML;
      this.render();
      this.setupEventListeners();
      this._isInitialized = true;
    
      // Check if accordion should be open by default
      if (this.hasAttribute('default-open')) {
        // Use setTimeout to ensure DOM is ready
        setTimeout(() => this.open(), 0);
      }
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue && this._isInitialized) {
      this.render();
      this.setupEventListeners();
      
      // Re-apply default open state if needed
      if (this.hasAttribute('default-open')) {
        setTimeout(() => this.open(), 0);
      }
    }
  }

  get heading() {
    return this.getAttribute('heading') || 'Accordion Heading';
  }

  get icon() {
    return this.getAttribute('icon') || 'plus';
  }

  render() {
    // Store original content
        // Use stored original content
    const content = this._originalContent || this.innerHTML;


    const iconSVG = this.icon === 'caret'
      ? `<svg class="pdp-accordion-icon icon-caret" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M11.9999 13.1714L16.9497 8.22168L18.3639 9.63589L11.9999 15.9999L5.63599 9.63589L7.0502 8.22168L11.9999 13.1714Z"></path>
        </svg>`
      : `<svg class="pdp-accordion-icon icon-plus" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line class="horizontal" x1="4" y1="12" x2="20" y2="12" />
          <line class="vertical" x1="12" y1="4" x2="12" y2="20" />
        </svg>`;

    this.innerHTML = `
      <div class="pdp-accordion-header">
        <div class="pdp-accordion-header-content">
          <p>${this.heading}</p>
        </div>
        ${iconSVG}
      </div>

      <div class="pdp-accordion-content">
        <div class="pdp-accordion-inner">
                    ${content}
        </div>
      </div>
    `;
  }

  setupEventListeners() {
    const header = this.querySelector('.pdp-accordion-header');
    const content = this.querySelector('.pdp-accordion-content');
    const inner = this.querySelector('.pdp-accordion-inner');
    const icon = this.querySelector('.pdp-accordion-icon');

    if (!header || !content || !inner) return;

    header.addEventListener('click', () => {
      if (content.classList.contains('open')) {
        content.style.maxHeight = '0px';
        content.classList.remove('open');
        if (icon) icon.classList.remove('rotate');
        this.dispatchEvent(new CustomEvent('accordion-close', { bubbles: true }));
      } else {
        content.classList.add('open');
        const height = inner.scrollHeight;
        content.style.maxHeight = height + 'px';
        if (icon) icon.classList.add('rotate');
        this.dispatchEvent(new CustomEvent('accordion-open', { bubbles: true }));
        
        // Recalculate height after rendering
        setTimeout(() => {
          if (content.classList.contains('open')) {
            content.style.maxHeight = inner.scrollHeight + 'px';
          }
        }, 50);
      }
    });
  }

  // Public API
  open() {
    const content = this.querySelector('.pdp-accordion-content');
    const inner = this.querySelector('.pdp-accordion-inner');
    const icon = this.querySelector('.pdp-accordion-icon');

    if (content && inner && !content.classList.contains('open')) {
      content.classList.add('open');
      content.style.maxHeight = inner.scrollHeight + 'px';
      if (icon) icon.classList.add('rotate');
      this.dispatchEvent(new CustomEvent('accordion-open', { bubbles: true }));
    }
  }

  close() {
    const content = this.querySelector('.pdp-accordion-content');
    const icon = this.querySelector('.pdp-accordion-icon');

    if (content && content.classList.contains('open')) {
      content.style.maxHeight = '0px';
      content.classList.remove('open');
      if (icon) icon.classList.remove('rotate');
      this.dispatchEvent(new CustomEvent('accordion-close', { bubbles: true }));
    }
  }

  toggle() {
    const content = this.querySelector('.pdp-accordion-content');
    if (content && content.classList.contains('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  isOpen() {
    const content = this.querySelector('.pdp-accordion-content');
    return content ? content.classList.contains('open') : false;
  }
}

// Register the custom element
customElements.define('pdp-accordion', PDPAccordion);